import OneStepTemplateCreation from "../../oneStepTemplateCreation/OneStepTemplateCreation";
import React, {useEffect, useState} from "react";
import {useSteps} from "../../../hooks/useSteps";
import useAppContext from "../../../hooks/useAppContext";
import CampaignTemplateEditForm from "../../campaignTemplateEditForm/CampaignTemplateEditForm";

interface CampaignStep1Props {
    onCancel: () => void;
    campaignId?: number;
    templateId?: number;
    onCompleted: (campaignId: number, templateId: number) => void;
}

const CampaignStep1 = ({ onCancel, campaignId, templateId, onCompleted }: CampaignStep1Props) => {
    const { goNext } = useSteps();
    const { data: { campaigns } } = useAppContext();
    const [template, setTemplate] = useState<any | null>(null);

    const onTemplateCreated = (id: number, campaignId: number) => {
        onCompleted(campaignId, id);
        goNext();
    }

    const onTemplateUpdated = () => {
        goNext();
    }

    useEffect(() => {
        const campaign = campaigns.data.find((campaign: any) => campaign.id === campaignId);
        const template = campaign?.templates?.[0];
        setTemplate(template || undefined);
    }, [campaigns, campaignId, templateId]);

    if(campaignId && template?.id) {
        return <CampaignTemplateEditForm campaignId={campaignId} template={template} onTemplateUpdated={onTemplateUpdated} onCancel={onCancel} />;
    } else {
        return <OneStepTemplateCreation onTemplateCreated={onTemplateCreated} onCancel={onCancel} isCampaign={true}/>;
    }
}

export default CampaignStep1;